<template>
  <div>
    <div :id="VIEW_LIST" v-if="viewType == VIEW_LIST">
      <div class="row center-block">
        <div class="col-md-12">
          <div class="box">
            <div class="box-header">
              <label for="recordPerPage" class="col-sm-1 col-md-1 col-lg-1"
                style="margin-top: 10px; text-align:left">Show</label>
              <div class="col-sm-2 col-md-2 col-lg-1" style="padding-left:0px;">
                <select v-on:change="changePageSize" ref="recordPerPage" class="form-control">
                  <option v-if="inquiryParam.pageSize == 5" selected>5</option>
                  <option v-else>5</option>
                  <option v-if="inquiryParam.pageSize == 10" selected>10</option>
                  <option v-else>10</option>
                  <option v-if="inquiryParam.pageSize == 20" selected>20</option>
                  <option v-else>20</option>
                  <option v-if="inquiryParam.pageSize == 50" selected>50</option>
                  <option v-else>50</option>
                  <option v-if="inquiryParam.pageSize == 100" selected>100</option>
                  <option v-else>100</option>
                </select>
              </div>
              <div class="box-tools">
                <button v-on:click="onCreate" class="btn btn-primary">Create</button>
                <button v-on:click="inquiry" class="btn btn-warning">Search</button>
              </div>
            </div>
            <div class="box-body no-padding table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="width: 45px;text-align:center;">#</th>
                    <th style="text-align:center;">Action</th>
                    <th style="text-align:center;">Name</th>
                    <th style="text-align:center;">Description</th>
                    <th style="text-align:center;">Valid From</th>
                    <th style="text-align:center;">Stock</th>
                    <th style="text-align:center;">Product Type</th>
                    <th style="text-align:center;">Product Category</th>
                    <th style="text-align:center;">Project</th>
                    <th style="text-align:center;">Barcode</th>
                    <th style="text-align:center;">Is Membership</th>
                    <th style="text-align:center;">Membership</th>
                    <th style="text-align:center;">Is Court</th>
                    <th style="text-align:center;">Court ID</th>
                    <th style="text-align:center;">PassCode Related</th>
                    <th style="text-align:left;">BINs</th>
                    <th style="text-align:left;">Material SAP</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in listData" v-bind:key="i">
                    <td style="width:45px;text-align:right;">{{ startSequence + i + 1 }}</td>
                    <td style="width:85px;text-align:right;">
                      <a href="#" v-on:click="onDisplay(row)" ref="displayRow" style="padding-right:5px">
                        <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                      </a>
                      <a href="#" v-on:click="onEdit(row)" ref="editRow" style="padding-right:5px">
                        <span class="icon ion-edit" data-toggle="tooltip" data-placement="right" title="Edit"></span>
                      </a>
                      <a href="#" v-on:click="onDelete(row)" ref="deleteRow" style="padding-right:5px">
                        <span class="icon ion-ios-trash" data-toggle="tooltip" data-placement="right" title="Delete"></span>
                      </a>
                    </td>
                    <td style="text-align:left;">{{ row.name }}</td>
                    <td style="text-align:left;">{{ row.description }}</td>
                    <td style="text-align:center;">{{ row.validFrom }}</td>
                    <td style="text-align:right;">{{ row.stock }}</td>
                    <td style="text-align:left;">{{ row.productTypeName }}</td>
                    <td style="text-align:left;">{{ row.productCategoryName }}</td>
                    <td style="text-align:left;">{{ row.projectName }}</td>
                    <td style="text-align:left;">{{ row.barcode }}</td>
                    <td style="text-align:center;">{{ row.isMembershipRelated }}</td>
                    <td style="text-align:left;">{{ row.membershipName }}</td>
                    <td style="text-align:center;">{{ row.isCourtRelated }}</td>
                    <td style="text-align:left;">{{ row.courtId }}</td>
                    <td style="text-align:center;">{{ row.isPassCodeRelated }}</td>
                    <td style="text-align:left;">{{ row.bankIdentificationNumber }}</td>
                    <td style="text-align:left;">{{ row.materialNoSAP }}</td>
                    <td style="text-align:right;">{{ row.bundleQty }}</td>
                    <td hidden>{{ row.id }}</td>
                    <td hidden>{{ row.productTypeId }}</td>
                    <td hidden>{{ row.productCategoryId }}</td>
                    <td hidden>{{ row.projectId }}</td>
                    <td hidden>{{ row.membershipId }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="box-footer">
              <div class="form-group">
                <label style="width:25px;text-align:right;">
                  <a href="#"><i v-on:click="changePage(1)" class="icon ion-ios-rewind"></i></a>
                </label>
                <label style="width:35px;text-align:center;">
                  <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber - 1)"
                      class="icon ion-arrow-left-b"></i></a>
                </label>
                <label>
                  Page
                </label>
                <label>
                  <input v-model="inquiryParam.CurrentPageNumber" v-on:keyup.enter="gotoPage($event)"
                    class="form-control" id="CurrentPage" style="width:50px;margin-left:5px;margin-right:5px;">
                </label>
                <label id="TotalPageText">
                  {{ totalPages }}
                </label>
                <label style="width:35px;text-align:center;">
                  <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber + 1)"
                      class="icon ion-arrow-right-b"></i></a>
                </label>
                <label style="width:25px;text-align:left;">
                  <a href="#"><i v-on:click="changePage(totalPages)" class="icon ion-ios-fastforward"></i></a>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :id="VIEW_KANBAN" v-if="viewType == VIEW_KANBAN">
      <div class="row center-block">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-6">
              <button v-on:click="onCreate()" class="btn btn-primary">Create</button>
            </div>
            <div class="col-md-6">
              <div class="row" style="margin-right:0px;margin-bottom:5px;">
                <div class="col-sm-3 col-md-3">
                  <div class="form-inline">
                    <label for="pagesize">Show</label>
                    <select id="pagesize" @change="changePageSize" ref="recordPerPage" class="form-control">
                      <option v-if="inquiryParam.pageSize == 5" selected>5</option>
                      <option v-else>5</option>
                      <option v-if="inquiryParam.pageSize == 10" selected>10</option>
                      <option v-else>10</option>
                      <option v-if="inquiryParam.pageSize == 20" selected>20</option>
                      <option v-else>20</option>
                      <option v-if="inquiryParam.pageSize == 50" selected>50</option>
                      <option v-else>50</option>
                      <option v-if="inquiryParam.pageSize == 100" selected>100</option>
                      <option v-else>100</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-9 col-md-9 has-feedback">
                  <div class="row">
                    <input type="text" class="form-control" v-on:keyup.enter="onSearch($event)"
                      placeholder="Search by product name">
                    <span class="icon ion-search form-control-feedback"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid" v-for="(row, i) in listData" v-bind:key="i">
        <div class="row" v-if="i % 4 === 0">
          <div class="col-md-3 col-sm-6 col-xs-12" v-if="listData[i] != undefined" @click="onDisplay(listData[i])">
            <div class="info-box" style="padding:5px;border-color:#d9d7d7;border:1px solid #d9d7d7">
              <div style="float:left;">
                <img class="attachment-img" :src="'/image/Product/' + listData[i].imageUrl + '?' + Date.now()"
                  alt="Product Image" style="width:64px;">
              </div>
              <div class="info-box-content" style="text-align:left;margin-left:70px;">
                <span class="info-box-text" style="text-transform:none;">{{ listData[i].name }}</span>
                <span class="info-box-number">{{ listData[i].stock }}</span>
              </div>
            </div>
          </div>

          <div class="col-md-3 col-sm-6 col-xs-12" v-if="listData[i + 1] != undefined"
            @click="onDisplay(listData[i + 1])">
            <div class="info-box" style="padding:5px;border-color:#d9d7d7;border:1px solid #d9d7d7">
              <div style="float:left;">
                <img class="attachment-img" :src="'/image/Product/' + listData[i + 1].imageUrl + '?' + Date.now()"
                  alt="Product Image" style="width:64px;">
              </div>
              <div class="info-box-content" style="text-align:left;margin-left:70px;">
                <span class="info-box-text" style="text-transform:none;">{{ listData[i + 1].name }}</span>
                <span class="info-box-number">{{ listData[i + 1].stock }}</span>
              </div>
            </div>
          </div>

          <div class="col-md-3 col-sm-6 col-xs-12" v-if="listData[i + 2] != undefined"
            @click="onDisplay(listData[i + 2])">
            <div class="info-box" style="padding:5px;border-color:#d9d7d7;border:1px solid #d9d7d7">
              <div style="float:left;">
                <img class="attachment-img" :src="'/image/Product/' + listData[i + 2].imageUrl + '?' + Date.now()"
                  alt="Product Image" style="width:64px;">
              </div>
              <div class="info-box-content" style="text-align:left;margin-left:70px;">
                <span class="info-box-text" style="text-transform:none;">{{ listData[i + 2].name }}</span>
                <span class="info-box-number">{{ listData[i + 2].stock }}</span>
              </div>
            </div>
          </div>

          <div class="col-md-3 col-sm-6 col-xs-12" v-if="listData[i + 3] != undefined"
            @click="onDisplay(listData[i + 3])">
            <div class="info-box" style="padding:5px;border-color:#d9d7d7;border:1px solid #d9d7d7">
              <div style="float:left;">
                <img class="attachment-img" :src="'/image/Product/' + listData[i + 3].imageUrl + '?' + Date.now()"
                  alt="Product Image" style="width:64px;">
              </div>
              <div class="info-box-content" style="text-align:left;margin-left:70px;">
                <span class="info-box-text" style="text-transform:none;">{{ listData[i + 3].name }}</span>
                <span class="info-box-number">{{ listData[i + 3].stock }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row center-block">
        <div class="col-md-12">
          <div class="row pull-right">
            <div class="form-group">
              <label style="width:25px;text-align:right;">
                <a href="#"><i v-on:click="changePage(1)" class="icon ion-ios-rewind"></i></a>
              </label>
              <label style="width:35px;text-align:center;">
                <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber - 1)"
                    class="icon ion-arrow-left-b"></i></a>
              </label>
              <label>
                Page
              </label>
              <label>
                <input v-model="inquiryParam.CurrentPageNumber" v-on:keyup.enter="gotoPage($event)" class="form-control"
                  id="CurrentPage" style="width:50px;margin-left:5px;margin-right:5px;">
              </label>
              <label id="TotalPageText">
                {{ totalPages }}
              </label>
              <label style="width:35px;text-align:center;">
                <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber + 1)"
                    class="icon ion-arrow-right-b"></i></a>
              </label>
              <label style="width:25px;text-align:left;">
                <a href="#"><i v-on:click="changePage(totalPages)" class="icon ion-ios-fastforward"></i></a>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div :id="VIEW_FORM" v-if="viewType == VIEW_FORM">
        <div class="row center-block">
          <div class="col-md-12">
            <div class="box box-info">
              <form @submit.prevent class="form-horizontal">
                <div class="box-body">
                  <div class="row">
                    <div class="col-md-2">
                      <div class="q_avatar" @mouseover="showImageControl(true)" @mouseleave="showImageControl(false)">
                        <img
                          :src="formData.imageUrl == '' ? (formData.picture ? formData.picture : '/static/img/placeholder.png') : '/image/Product/' + formData.imageUrl + '?' + Date.now()"
                          class="img img-responsive" border="1" ref="productImage">
                        <div class="q_form_image_controls" ref="imageControl">
                          <span class="icon ion-pencil pull-left q_select_file_button" title="Edit"
                            @click="$refs.filePicture.click()"></span>
                          <span class="icon ion-ios-trash-o pull-right q_clear_file_button" title="Clear"
                            @click="clearPicture()"></span>
                          <div class="q_hidden_input_file ">
                            <input type="file" accept="image/*" ref="filePicture" @change="pictureChange">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-5">
                      <div class="form-group">
                        <label for="inputName">Name</label>
                        <h1 style="margin-top:0px;">
                          <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputName"
                            placeholder="Product Name" v-model="formData.name">
                        </h1>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="nav-tabs-custom">
                        <ul class="nav nav-tabs">
                          <li v-bind:class="{ active: tabActive == TAB_GENERAL }"><a href="#tab_1" data-toggle="tab"
                              aria-expanded="true">General</a></li>
                          <li v-bind:class="{ active: tabActive == TAB_PRICELIST }"><a @click="onClickTabPriceList()"
                              href="#tab_2" data-toggle="tab" aria-expanded="true">Price List</a></li>
                        </ul>
                      </div>
                      <div class="tab-content">
                        <div v-bind:class="{ active: tabActive == TAB_GENERAL }" class="tab-pane" id="tab_1">
                          <div class="box no-border">
                            <div class="row">
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="inputDescription" class="col-sm-4 control-label">Description</label>
                                  <div class="col-md-8">
                                    <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control"
                                      id="inputDescription" placeholder="" v-model="formData.description">
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="inputStock" class="col-sm-4 control-label">Stock</label>
                                  <div class="col-sm-8">
                                    <input type="text" @keyup="formattingNumber($event)" ref="inputStock"
                                      :readonly="viewMode == MODE_VIEW ? true : false" class="form-control"
                                      id="inputStock" placeholder="" v-model="formData.stock">
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="inputProductType" class="col-sm-4 control-label">Product Type</label>
                                  <div class="col-sm-8">
                                    <select v-model="formData.productTypeId" class="form-control"
                                      :disabled="viewMode == MODE_VIEW ? true : false">
                                      <option v-for="(row, i) in listProductType" v-bind:key="i" v-bind:value="row.id">
                                        {{ row.name }}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="inputBarcode" class="col-sm-4 control-label">Barcode</label>
                                  <div class="col-sm-8">
                                    <input type="text" @keyup="formattingNumber($event)" ref="inputBarcode"
                                      :readonly="viewMode == MODE_VIEW ? true : false" class="form-control"
                                      id="inputBarcode" placeholder="" v-model="formData.barcode">
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="inputProductCategory" class="col-sm-4 control-label">Product
                                    Category</label>
                                  <div class="col-sm-8">
                                    <select v-model="formData.productCategoryId" class="form-control"
                                      :disabled="viewMode == MODE_VIEW ? true : false">
                                      <option v-for="(row, i) in listProductCategory" v-bind:key="i"
                                        v-bind:value="row.id">
                                        {{ row.name }}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <div class="col-md-offset-2 col-md-3">
                                    <div class="checkbox">
                                      <label>
                                        <input type="checkbox"> Membership
                                      </label>
                                    </div>
                                  </div>
                                  <div class="col-md-7">
                                    <select v-model="formData.membershipId" class="form-control"
                                      :disabled="viewMode == MODE_VIEW ? true : false">
                                      <option v-for="(row, i) in listMembership" v-bind:key="i" v-bind:value="row.id">
                                        {{ row.name }}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="inputProject" class="col-sm-4 control-label">Project</label>
                                  <div class="col-sm-8">
                                    <select v-model="formData.projectId" class="form-control"
                                      :disabled="viewMode == MODE_VIEW ? true : false">
                                      <option v-for="(row, i) in listProject" v-bind:key="i" v-bind:value="row.id">
                                        {{ row.name }}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="inputValidFrom" class="col-sm-4 control-label">Valid From</label>
                                  <div class="col-sm-8">
                                    <div class="input-group">
                                      <datepicker style="width:100%" v-if="showValidFrom" :readonly="true"
                                        name="validFrom" :value=formData.validFrom :format=DATE_FORMAT
                                        :input-attr="{ 'id': 'validFrom', 'disabled': viewMode == MODE_VIEW ? true : false }"
                                        :input-style="{ 'width': '100%' }"></datepicker>
                                      <span class="input-group-addon">
                                        <i class="icon ion-calendar"></i>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="inputIsPassCodeRelated" class="col-sm-4 control-label">PassCode
                                    Related</label>
                                  <div class="col-md-8">
                                    <input :disabled="viewMode == MODE_VIEW" type="checkbox" id="inputIsPassCodeRelated"
                                      v-model="formData.isPassCodeRelated">
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <div class="col-md-offset-2 col-md-3">
                                    <div class="checkbox">
                                      <label>
                                       <input :disabled="viewMode == MODE_VIEW" type="checkbox" id="inputIsCourtRelated"
                                      v-model="formData.isCourtRelated"> Court
                                      </label>
                                    </div>
                                  </div>
                                  <div class="col-md-7">
                                    <select v-model="formData.courtId" class="form-control"
                                      :disabled="viewMode == MODE_VIEW ? true : false">
                                      <option v-for="(row, i) in listCourt" v-bind:key="i" v-bind:value="row.id">
                                        {{ row.name }}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="inputBundleQty" class="col-sm-4 control-label">Budle Qty</label>
                                  <div class="col-md-8">
                                    <input type="text" @keyup="formattingNumber($event)" ref="inputBundleQty"
                                      :readonly="viewMode == MODE_VIEW ? true : false" class="form-control"
                                      id="inputBundleQty" placeholder="" v-model="formData.bundleQty">
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="inputThirdParty" class="col-sm-4 control-label">Third Party
                                    Cost(%)</label>
                                  <div class="col-md-8">
                                    <input type="text" @keyup="formattingNumber($event)" ref="inputThirdParty"
                                      :readonly="viewMode == MODE_VIEW ? true : false" class="form-control"
                                      id="inputThirdParty" placeholder="" v-model="formData.thirdPartyPercentage">
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="inputBIN" class="col-sm-4 control-label">Bank Identification No.</label>
                                  <div class="col-sm-8">
                                    <input type="text" :readonly="viewMode == MODE_VIEW ? true : false"
                                      class="form-control" id="inputBIN" placeholder=""
                                      v-model="formData.bankIdentificationNumber">
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="inputBundleQty" class="col-sm-4 control-label">Third Party Cost</label>
                                  <div class="col-md-8">
                                    <input type="text" @keyup="formattingNumber($event)" ref="inputBundleQty"
                                      :readonly="viewMode == MODE_VIEW ? true : false" class="form-control"
                                      id="inputBundleQty" placeholder="" v-model="formData.thirdPartyFixedAmount">
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="inputMaterialNoSAP" class="col-sm-4 control-label">Material No. SAP</label>
                                  <div class="col-sm-8">
                                    <input type="text" :readonly="viewMode == MODE_VIEW ? true : false"
                                      class="form-control" id="inputMaterialNoSAP" placeholder=""
                                      v-model="formData.materialNoSAP">
                                  </div>  
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-bind:class="{ active: tabActive == TAB_PRICELIST }" class="tab-pane" id="tab_2">
                          <div class="box no-border" >
                            <div class="box-header " v-if="this.formData.id !== 0">
                              <button data-toggle="modal"  data-target="#modal-addPrice" class="btn btn-success pull-right">Create Price</button>
                            </div>
                            <div class="box-body no-padding table-responsive">
                              <table class="table table-striped">
                                <thead>
                                  <tr>
                                    <th style="width:10px;text-align:right">#</th>
                                    <th style="text-align:center;">Valid From</th>
                                    <th style="text-align:center;">Time</th>
                                    <th style="text-align:right;">Price WeekEnd</th>
                                    <th style="text-align:right;">Price WeekDay</th>
                                    <th style="text-align:right;">Discount</th>
                                    <th style="text-align:right;">Discount(%)</th>
                                    <th style="text-align:right;">Tax</th>
                                    <th style="text-align:center;">Currency</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(row, i) in listPrice" v-bind:key="i">
                                    <td style="text-align:right;">{{ startSequence + i + 1 }}</td>
                                    <td style="text-align:center;">{{ row.validFrom }}</td>
                                    <td style="text-align:center;">{{ row.time }}</td>
                                    <td style="text-align:right;">{{ row.priceWeekEnd }}</td>
                                    <td style="text-align:right;">{{ row.priceWeekDay }}</td>
                                    <td style="text-align:right;">{{ row.discountPrice }}</td>
                                    <td style="text-align:right;">{{ row.discountPercentage }}</td>
                                    <td style="text-align:right;">{{ row.tax }}</td>
                                    <td style="text-align:center;">{{ row.currencyName }}</td>
                                    <td hidden>{{ row.id }}</td>
                                    <td hidden>{{ row.productId }}</td>
                                    <td hidden>{{ row.currencyId }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <input type="hidden" class="form-control" id="inputId" v-model="formData.id">
                  <input type="hidden" class="form-control" id="inputProductTypeId" v-model="formData.productTypeId">
                  <input type="hidden" class="form-control" id="inputProductCategoryId"
                    v-model="formData.productCategoryId">
                  <input type="hidden" class="form-control" id="inputProjectId" v-model="formData.projectId">
                  <input type="hidden" class="form-control" id="inputmembershipId" v-model="formData.membershipId">
                </div>

                <div class="box-footer">
                  <div class="box-tools">
                    <button @click="onBack()" class="btn btn-default" style="margin-right:15px;">Back</button>
                    <button @click="onCancel()" class="btn btn-warning">Cancel</button>
                    <button v-if="viewMode != MODE_VIEW" @click="onSave()" class="btn btn-info pull-right">Save</button>
                    <button v-if="viewMode == MODE_VIEW" @click="onEdit(formData)"
                      class="btn btn-info pull-right">Edit</button>
                    <button v-if="viewMode == MODE_VIEW" @click="onCreate()" class="btn btn-info pull-right"
                      style="margin-right:15px;">Create</button>
                  </div>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <div class="modal fade" id="modal-addPrice">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="form-horizontal">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span></button>
              <h4 class="modal-title">Add Price</h4>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label for="inputValidFrom" class="col-sm-2 control-label">Valid From</label>
                <div class="col-sm-10">
                  <div class="input-group">
                    <datepicker style="width:100%" v-if="showValidFrom" :readonly="true" name="validFromPrice"
                      :value=formDataPrice.validFromPrice :format=DATE_FORMAT :input-attr="{ 'id': 'validFromPrice' }"
                      :input-style="{ 'width': '100%' }">
                    </datepicker>
                    <span class="input-group-addon">
                      <i class="icon ion-calendar"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="inputTime" class="col-sm-2 control-label">Time</label>
                <div class="col-sm-10">
                  <select v-model="formDataPrice.courtScheduleId" class="form-control">
                    <option v-for="(row, i) in listTime" v-bind:key="i" v-bind:value="row.id">
                      {{ row.schedule_time }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label for="inputPriceWeekDay" class="col-sm-2 control-label">Price (WeekDay)</label>
                <div class="col-sm-10">
                  <input type="text" @keyup="formattingNumber($event)" ref="inputPriceWeekDay" class="form-control"
                    id="inputPriceWeekDay" placeholder="" v-model="formDataPrice.priceWeekDay">
                </div>
              </div>
              <div class="form-group">
                <label for="inputPriceWeekEnd" class="col-sm-2 control-label">Price (WeekEnd)</label>
                <div class="col-sm-10">
                  <input type="text" @keyup="formattingNumber($event)" ref="inputPriceWeekEnd" class="form-control"
                    id="inputPriceWeekEnd" placeholder="" v-model="formDataPrice.priceWeekEnd">
                </div>
              </div>
              <div class="form-group">
                <label for="inputDiscountPrice" class="col-sm-2 control-label">Discount</label>
                <div class="col-sm-10">
                  <input type="text" @keyup="formattingNumber($event)" ref="inputDiscountPrice" class="form-control"
                    id="inputDiscountPrice" placeholder="" v-model="formDataPrice.discountPrice">
                </div>
              </div>
              <div class="form-group">
                <label for="inputDiscountPercentage" class="col-sm-2 control-label">Discount(%)</label>
                <div class="col-sm-10">
                  <input type="text" @keyup="formattingNumber($event)" ref="inputDiscountPercentage"
                    class="form-control" id="inputDiscountPercentage" placeholder=""
                    v-model="formDataPrice.discountPercentage">
                </div>
              </div>
              <div class="form-group">
                <label for="inputTax" class="col-sm-2 control-label">Tax</label>
                <div class="col-sm-10">
                  <input type="text" @keyup="formattingNumber($event)" ref="inputTax" class="form-control" id="inputTax"
                    placeholder="" v-model="formDataPrice.tax">
                </div>
              </div>
              <div class="form-group">
                <label for="inputCurrency" class="col-sm-2 control-label">Currency</label>
                <div class="col-sm-10">
                  <select v-model="formDataPrice.currencyId" class="form-control">
                    <option v-for="(row, i) in listCurrency" v-bind:key="i" v-bind:value="row.id">
                      {{ row.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal"
              ref="btnCloseModal">Close</button>
            <button type="button" @click="onCreatePrice()" class="btn btn-primary">
              <span v-if="loadingPriceSave"><i class="icon ion-spinner fa-spin"></i> Saving...</span>
              <span v-else>Save</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import api from '../../api'
import SweetAlert from 'sweetalert2'
import datepicker from '../../components/widgets/DatePicker'
import config from '../../config'
import utilities from '../../utilities'
import axios from 'axios'
import moment from 'moment'

const VIEW_LIST = 'list'
const VIEW_KANBAN = 'kanban'
const VIEW_FORM = 'form'
const MODE_NONE = 'none'
const MODE_CREATE = 'create'
const MODE_VIEW = 'read'
const MODE_UPDATE = 'update'
const TAB_GENERAL = 'tabGeneral'
const TAB_PRICELIST = 'tabPriceList'

export default {
  name: 'Product',
  components: {
    datepicker
  },
  data() {
    return {
      DATE_FORMAT: config.dateFormat,
      DATE_FORMAT_SQL: config.dateFormatSql,
      VIEW_LIST: VIEW_LIST,
      VIEW_KANBAN: VIEW_KANBAN,
      VIEW_FORM: VIEW_FORM,
      MODE_NONE: MODE_NONE,
      MODE_VIEW: MODE_VIEW,
      MODE_UPDATE: MODE_UPDATE,
      TAB_GENERAL: TAB_GENERAL,
      TAB_PRICELIST: TAB_PRICELIST,
      currentStatus: null,
      column: '',
      item: null,
      listData: null,
      listTime: null,
      totalRows: 0,
      totalPages: 0,
      startSequence: 0,
      inquiryParam: {
        WhereClause: '',
        CurrentPageNumber: 1,
        PageSize: 10,
        SortDirection: 'ASC',
        SortExpression: 'Name',
        WhereClauseByProject: ''
      },
      viewType: VIEW_LIST,
      viewMode: MODE_NONE,
      formData: {
        id: 0,
        name: '',
        description: '',
        validFrom: '',
        stock: '',
        picture: null,
        productTypeName: '',
        productCategoryName: '',
        projectName: '',
        barcode: '',
        isMembershipRelated: false,
        membershipName: '',
        productTypeId: 0,
        productCategoryId: 0,
        projectId: 0,
        membershipId: 0,
        imageUrl: '',
        isPassCodeRelated: false,
        bankIdentificationNumber: '',
        isCourtRelated: false,
        courtId: '',
        bundleQty: '',
        thirdPartyPercentage: 0,
        thirdPartyFixedAmount: 0,
        materialNoSAP: ''
      },
      formDataPrice: {
        id: 0,
        productId: 0,
        courtId: '',
        validFrom: '',
        time: '',
        priceWeekDay: 0,
        priceWeekEnd: 0,
        currencyId: 0,
        discountPrice: 0,
        discountPercentage: 0,
        tax: 0,
        courtScheduleId: ''
      },
      tabActive: '',
      listMembership: null,
      listCourt: null,
      listProductType: null,
      listProductCategory: null,
      listProject: null,
      listCurrency: null,
      listPrice: null,
      showValidFrom: false,
      loadingPriceSave: false
    }
  },
  computed: {
  },
  created() {
    this.viewType = VIEW_KANBAN
    this.inquiry()
  },
  mounted() {
    this.$refs.recordPerPage.value = this.inquiryParam.PageSize
    this.$root.$on('inquiryProductByProject', (projectIds) => {
      this.projectIds = projectIds
      return this.inquiry()
    })
    this.listTime = [{
      id: '',
      court_id: '',
      seq_no: 0,
      schedule_time: '00:00:00',
      occupancy: 0,
      deletion_flag: false,
      product_id: 0
    }]
  },
  methods: {
    changePageSize(evt) {
      this.inquiryParam.PageSize = evt.target.value
      this.inquiryParam.CurrentPageNumber = 1
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    gotoPage(evt) {
      if (evt.target.value > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else if (evt.target.value < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    changePage(page) {
      if (page < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      } else if (page > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else {
        this.inquiryParam.CurrentPageNumber = page
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    showImageControl(show) {
      if (this.viewMode === MODE_VIEW) {
        return
      }
      let el = this.$refs.imageControl
      el.style.opacity = show ? 0.8 : 0
    },
    pictureChange(e) {
      const image = e.target.files[0]
      const reader = new FileReader()
      reader.readAsDataURL(image)
      reader.onload = e => {
        this.formData.picture = e.target.result
        this.$refs.productImage.src = e.target.result
      }
    },
    clearPicture() {
      this.formData.picture = null
      this.formData.imageUrl = ''
    },
    onSearch(evt) {
      var keyWords = evt.target.value
      var whereClause = ['Name', 'like', '\'%' + keyWords + '%\'']
      this.inquiryParam.WhereClause = whereClause.join(' ')
      this.inquiry()
    },
    inquiry() {
      this.inquiryParam.WhereClauseByProject = ''
      if (this.$store.state.userInfo.projects && this.$store.state.userInfo.projects.length > 0) {
        this.inquiryParam.WhereClauseByProject = 'ProjectId IN (' + this.$store.state.userInfo.projects.join() + ')'
        this.inquiryParam.WhereClauseByProject = this.inquiryParam.WhereClause === '' ? this.inquiryParam.WhereClauseByProject : this.inquiryParam.WhereClauseByProject + ' AND '
      }

      api
        .request('Sales', 'get', '/api/Product/Inquiry?WhereClause=' + this.inquiryParam.WhereClauseByProject + this.inquiryParam.WhereClause +
          '&PageSize=' + this.inquiryParam.PageSize + '&CurrentPageNumber=' + this.inquiryParam.CurrentPageNumber +
          '&SortDirection=' + this.inquiryParam.SortDirection + '&SortExpression=' + this.inquiryParam.SortExpression, null)
        .then(response => {
          var data = response.data
          this.listData = data.entity
          this.total = data.totalRows
          this.totalPages = data.totalPages
          this.$refs.recordPerPage.value = this.inquiryParam.PageSize
        })
        .catch(error => {
          // var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          var message = error.message
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getCurrency() {
      api
        .request('Account', 'get', '/api/Currency/InquiryAll', null)
        .then(response => {
          var data = response.data
          this.listCurrency = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getProject() {
      api
        .request('Account', 'get', '/api/Project/InquiryAll', null)
        .then(response => {
          var data = response.data
          this.listProject = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getProductType() {
      api
        .request('Sales', 'get', '/api/ProductType/InquiryAll', null)
        .then(response => {
          var data = response.data
          this.listProductType = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getProductCategory() {
      api
        .request('Sales', 'get', '/api/ProductCategory/InquiryAll', null)
        .then(response => {
          var data = response.data
          this.listProductCategory = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getMembership() {
      api
        .request('Guest', 'get', '/api/Membership/InquiryAll', null)
        .then(response => {
          var data = response.data
          this.listMembership = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getCourt() {
      api
        .request('Guest', 'get', '/api/Reservation/Court?WhereClause=' + 'project_id IN (' + this.$store.state.userInfo.projects.join() + ')' +
          '&PageSize=999' + '&CurrentPageNumber=1' + '&SortDirection=DESC' + '&SortExpression=valid_from', null)
        .then(response => {
          var data = response.data
          this.listCourt = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getCourtSchedule() {
      this.listTime = [{
        id: '',
        court_id: '',
        seq_no: 0,
        schedule_time: '00:00:00',
        occupancy: 0,
        deletion_flag: false,
        product_id: 0
      }]
      if (this.formData.courtId !== '') {
        let validFrom = moment(this.formData.validFrom, this.DATE_FORMAT)
        validFrom = moment(validFrom).format(this.DATE_FORMAT_SQL)

        const requestCourtSchedule = api.request('Reservation', 'get', '/api/Reservation/Court/' + this.formData.courtId + '/Schedule', null)
        const requestPriceAlreadySetUp = api.request('Sales', 'get', '/api/Price/Inquiry?WhereClause=ProductId=' + this.formData.id +
          ' AND Price.ValidFrom = \'' + validFrom + '\'' + '&PageSize=99999&CurrentPageNumber=1&SortDirection=ASC&SortExpression=id', null)
        axios
          .all([requestCourtSchedule, requestPriceAlreadySetUp])
          .then(
            axios.spread((...response) => {
              const responseCourtSchedule = response[0]
              const responsePriceAlreadySetUp = response[1]

              if (responseCourtSchedule.data.returnStatus && responsePriceAlreadySetUp.data.returnStatus) {
                this.listTime = responseCourtSchedule.data.entity

                responsePriceAlreadySetUp.data.entity.forEach(element => {
                  for (var i = 0; i < this.listTime.length; i++) {
                    if (this.listTime[i].id === element.courtScheduleId && this.listTime[i].id !== this.formData.courtScheduleId) {
                      this.listTime.splice(i, 1)
                    }
                  }
                })
              } else {
                let message = responseCourtSchedule.data.returnMessage.join('<br>') + '<br>' + responsePriceAlreadySetUp.data.returnMessage.join('<br>')
                SweetAlert.fire('Error', message, 'error')
              }
            })
          )
          .catch(error => {
            SweetAlert.fire('Error', error.message, 'error')
          })
      }
    },
    getMasterData() {
      this.getProductType()
      this.getProductCategory()
      this.getProject()
      this.getMembership()
      this.getCourt()
    },
    initForm() {
      this.formData.id = 0
      this.formData.name = ''
      this.formData.description = ''
      this.formData.productTypeId = 0
      this.formData.productCategoryId = 0
      this.formData.projectId = 0
      this.formData.validFrom = ''
      this.formData.stock = ''
      this.formData.barcode = ''
      this.formData.isMembershipRelated = false
      this.formData.membershipId = 0
      this.formData.imageUrl = ''
      this.formData.picture = null
      this.formData.isPassCodeRelated = false
      this.formData.bankIdentificationNumber = ''
      this.formData.isCourtRelated = false
      this.formData.courtId = ''
      this.formData.bundleQty = ''
      this.formData.thirdPartyPercentage = 0
      this.formData.thirdPartyFixedAmount = 0
      this.formData.materialNoSAP = ''

      this.showValidFrom = false
      this.$nextTick(() => {
        this.showValidFrom = true
      })
    },
    onCreate() {
      this.initForm()
      this.viewType = VIEW_FORM
      this.viewMode = MODE_CREATE
      this.getMasterData()
      this.tabActive = TAB_GENERAL
    },
    toDataURL(url, callback) {
      var xhr = new XMLHttpRequest()
      xhr.onload = function () {
        var reader = new FileReader()
        reader.onloadend = function () {
          callback(reader.result)
        }
        reader.readAsDataURL(xhr.response)
      }
      xhr.open('GET', url)
      xhr.responseType = 'blob'
      xhr.send()
    },
    onDisplay(row) {
      this.viewType = VIEW_FORM
      this.viewMode = MODE_VIEW
      this.tabActive = TAB_GENERAL

      this.getMasterData()
      var me = this
      api
        .request('Sales', 'get', '/api/Product/GetDetail?Id=' + row.id, null)
        .then(response => {
          var data = response.data
          this.formData.id = data.entity.id
          this.formData.name = data.entity.name
          this.formData.description = data.entity.description
          this.formData.productTypeId = data.entity.productTypeId
          this.formData.productCategoryId = data.entity.productCategoryId
          this.formData.projectId = data.entity.projectId
          this.formData.validFrom = data.entity.validFrom
          this.formData.stock = data.entity.stock
          this.formData.barcode = data.entity.barcode
          this.formData.isMembershipRelated = data.entity.isMembershipRelated
          this.formData.membershipId = data.entity.membershipId
          this.formData.isPassCodeRelated = data.entity.isPassCodeRelated
          this.formData.bankIdentificationNumber = data.entity.bankIdentificationNumber
          this.formData.isCourtRelated = data.entity.isCourtRelated
          this.formData.courtId = data.entity.courtId
          this.formData.imageUrl = data.entity.imageUrl
          this.formData.picture = data.entity.picture
          this.formData.bundleQty = data.entity.bundleQty
          this.formData.thirdPartyFixedAmount = data.entity.thirdPartyFixedAmount
          this.formData.thirdPartyPercentage = data.entity.thirdPartyPercentage
          this.formData.materialNoSAP = data.entity.materialNoSAP

          this.showValidFrom = false
          this.$nextTick(() => {
            this.showValidFrom = true
          })
        })
        .then(response => {
          this.toDataURL(me.$refs.productImage.src, function (dataUrl) {
            me.formData.picture = dataUrl
          })
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onEdit(data) {
      this.formData.id = data.id
      this.formData.name = data.name
      this.formData.description = data.description
      this.formData.productTypeId = data.productTypeId
      this.formData.productCategoryId = data.productCategoryId
      this.formData.projectId = data.projectId
      this.formData.validFrom = data.validFrom
      this.formData.stock = data.stock
      this.formData.barcode = data.barcode
      this.formData.isMembershipRelated = data.isMembershipRelated
      this.formData.membershipId = data.membershipId
      this.formData.isPassCodeRelated = data.isPassCodeRelated
      this.formData.bankIdentificationNumber = data.bankIdentificationNumber
      this.formData.isCourtRelated = data.isCourtRelated
      this.formData.courtId = data.courtId
      this.formData.imageUrl = data.imageUrl
      this.formData.picture = undefined
      this.formData.bundleQty = data.bundleQty
      this.formData.thirdPartyFixedAmount = data.thirdPartyFixedAmount
      this.formData.thirdPartyPercentage = data.thirdPartyPercentage
      this.formData.materialNoSAP = data.materialNoSAP
      this.viewType = VIEW_FORM
      this.viewMode = MODE_UPDATE

      let me = this
      this.toDataURL(me.$refs.productImage.src, function (dataUrl) {
        me.formData.picture = dataUrl
        me.formData.imageUrl = ''
      })
    },
    onDelete(data) {
      SweetAlert.fire({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: true
      })
        .then((result) => {
          if (result.value) {
            var res = this.delete(data)
            SweetAlert.fire('Deleted', res.message, res.status)
          } else if (result.dismiss === SweetAlert.DismissReason.cancel) {
            SweetAlert.fire('Cancelled', 'Your data is still exist', 'info')
          }
        })
    },
    onCancel() {
      this.initForm()
    },
    onBack() {
      this.inquiry()
      this.viewType = VIEW_KANBAN
    },
    onSave() {
      var data = {
        Id: this.formData.id,
        Name: this.formData.name,
        Description: this.formData.description,
        ProductTypeId: this.formData.productTypeId,
        ProductCategoryId: this.formData.productCategoryId,
        ProjectId: this.formData.projectId,
        Stock: this.formData.stock,
        Barcode: this.formData.barcode,
        ValidFrom: $('#validFrom').val(), // this.formData.validFrom,
        IsMembershipRelated: this.formData.isMembershipRelated,
        MembershipId: this.formData.membershipId,
        IsPassCodeRelated: this.formData.isPassCodeRelated,
        BankIdentificationNumber: this.formData.bankIdentificationNumber,
        IsCourtRelated: this.formData.isCourtRelated,
        CourtId: this.formData.courtId,
        ImageBase64String: this.formData.picture,
        BundleQty: this.formData.bundleQty,
        ThirdPartyPercentage: this.formData.thirdPartyPercentage,
        ThirdPartyFixedAmount: this.formData.thirdPartyFixedAmount,
        MaterialNoSAP: this.formData.materialNoSAP
      }

      var status = 'success'
      var message = ''
      var method = ''
      switch (this.viewMode) {
        case MODE_CREATE:
          method = 'Create'
          break
        case MODE_UPDATE:
          method = 'Update'
          break
      }

      api
        .request('Sales', 'post', '/api/Product/' + method, data)
        .then(response => {
          var resData = response.data
          this.formData = resData.entity

          if (resData.returnStatus) {
            this.onDisplay({ id: this.formData.id, name: this.formData.name })
          }

          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')
          SweetAlert.fire(status, message, status)
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    delete(data) {
      var status = ''
      var message = ''
      var reqData = {
        Id: data.id,
        Name: data.name
      }
      api.request('Sales', 'post', '/api/Product/Delete', reqData)
        .then(response => {
          var resData = response.data
          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage
          this.inquiry()
        })
        .catch(error => {
          status = 'error'
          message = 'Error happens when call API delete: ' + error.message
        })
      return { status: status, message: message }
    },
    onClickTabPriceList() {
      this.getCurrency()
      this.getCourtSchedule()
      this.tabActive = TAB_PRICELIST
      api
        .request('Sales', 'get', '/api/Price/Inquiry?WhereClause=ProductId = ' + this.formData.id +
          '&PageSize=999' + '&CurrentPageNumber=1' + '&SortDirection=DESC' + '&SortExpression=ValidFrom', null)
        .then(response => {
          var data = response.data
          this.listPrice = data.entity

          var currencyName
          this.listPrice.forEach(itemPrice => {
            currencyName = ''
            this.listCurrency.some(function (itemCurrency, index) {
              if (itemPrice.currencyId === itemCurrency.id) {
                currencyName = itemCurrency.name
              }
            })
            itemPrice.currencyName = currencyName
          })
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    // price
    formattingNumber(evt) {
      if ($.inArray(evt.keyCode, [9, 38, 40, 37, 39]) !== -1) {
        return
      }// When the arrow keys are pressed, etc..., abort.

      var input = this.$refs[evt.target.id].value
      var inputNumber = utilities.ParseNumber(input)
      this.$refs[evt.target.id].value = utilities.DisplayNumber(inputNumber)
      switch (evt.target.id) {
        case 'inputPriceWeekDay':
          this.formDataPrice.priceWeekDay = utilities.DisplayNumber(inputNumber)
          break
        case 'inputPriceWeekEnd':
          this.formDataPrice.priceWeekEnd = utilities.DisplayNumber(inputNumber)
          break
        case 'inputDiscountPrice':
          this.formDataPrice.discountPrice = utilities.DisplayNumber(inputNumber)
          break
        case 'inputDiscountPercentage':
          this.formDataPrice.discountPercentage = utilities.DisplayNumber(inputNumber)
          break
        case 'inputTax':
          this.formDataPrice.tax = utilities.DisplayNumber(inputNumber)
          break
        default:
          break
      }
    },
    onCreatePrice() {
      this.loadingPriceSave = true
      let timeChoosen = this.listTime.find(x => x.id === this.formDataPrice.courtScheduleId)
      this.formDataPrice.time = timeChoosen === undefined ? '00:00:00' : timeChoosen.schedule_time

      var data = {
        Id: this.formDataPrice.id,
        ProductId: this.formData.id,
        CourtId: this.formDataPrice.courtId,
        ValidFrom: $('#validFromPrice').val(),
        Time: this.formDataPrice.time,
        PriceWeekDay: this.formDataPrice.priceWeekDay,
        PriceWeekEnd: this.formDataPrice.priceWeekEnd,
        DiscountPrice: this.formDataPrice.discountPrice,
        DiscountPercerntage: this.formDataPrice.discountPercentage,
        Tax: this.formDataPrice.tax,
        CurrencyId: this.formDataPrice.currencyId,
        CourtScheduleId: this.formDataPrice.courtScheduleId
      }

      var status = 'success'
      var message = ''
      var method = 'Create'

      api
        .request('Sales', 'post', '/api/Price/' + method, data)
        .then(response => {
          var resData = response.data
          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')
          SweetAlert.fire(status, message, status)
          this.loadingPriceSave = false
          this.onClickTabPriceList()
          this.$refs.btnCloseModal.click()
        })
        .catch(error => {
          this.loadingPriceSave = false
          let returnMessageAnother = 'Another Error'
          if (error.response && error.response.data && Array.isArray(error.response.data.returnMessage)) {
            returnMessageAnother = error.response.data.returnMessage.join('<br>')
          }
          const message = error.message + ':<br>' + returnMessageAnother
          SweetAlert.fire('Error', message, 'error')
        })
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}

input[type=text],
select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}

input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}

.q_avatar {
  float: left;
  box-sizing: border-box;
  position: relative;
  text-align: inherit;
}

.q_avatar>img {
  max-height: 90px;
  max-width: 90px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  border: none;
}

.q_form_image_controls {
  position: absolute;
  top: 0;
  left: auto;
  bottom: auto;
  right: 0;
  width: 100%;
  color: white;
  background-color: #337AB7;
  opacity: 0;
  transition: opacity ease 400ms;
}

.q_hidden_input_file {
  position: absolute;
  top: 1px;
  opacity: 0;
  width: 100%;
  height: 26px;
  display: none;
}

.q_form_image_controls>.fa {
  margin: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// Product.vue?45e32b7a